import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 18.61 39.81' {...props}>
    <path
      d='M4 7.71v5.48H0v6.7h4v19.92h8.26V19.89h5.54s.52-3.21.77-6.73h-6.26V8.58A2 2 0 0 1 14.11 7h4.5V0h-6.13C3.82 0 4 6.71 4 7.71'
      fill='undefined'
      data-name='Layer 2'
    />
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/FacebookIcon.js